import { render } from "./ServiceIndex.vue?vue&type=template&id=482eeb72"
import script from "./ServiceIndex.vue?vue&type=script&lang=js"
export * from "./ServiceIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__